import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageExitSvg';

export const ResponsesImageExit = createResponsesImage({
  name: 'ResponsesImageExit',
  component,
});
